/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAllUsersTermsConditionsResponse } from '../../models/get-all-users-terms-conditions-response';

export interface GetTermsAndConditions$Params {
  pageSize?: number;
  page?: number;
}

export function getTermsAndConditions(http: HttpClient, rootUrl: string, params?: GetTermsAndConditions$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllUsersTermsConditionsResponse>> {
  const rb = new RequestBuilder(rootUrl, getTermsAndConditions.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('page', params.page, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAllUsersTermsConditionsResponse>;
    })
  );
}

getTermsAndConditions.PATH = '/api/v2/terms-and-conditions';
